import $ from "jquery";
import "@fortawesome/fontawesome-free/css/all.min.css";
//import "./menu-group-colors";
import "./video";
import "./slider";
import "./accordeon";
import "./tab";

$(document).ready(function () { })
